import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Login from "./pages/login";
import Principal from './pages/principal';
import Configuracao from './pages/configuracao';
import CadSetor from './pages/cadastro/cadsetor';
import CadFuncao from './pages/cadastro/cadfuncao';
import CadColaborador from './pages/cadastro/cadcolaborador';
import CadEquipe from './pages/cadastro/cadequipe';
import CadTitulo from './pages/cadastro/cadtitulo';
import CadDesafio from './pages/cadastro/caddesafio';
import CadCheckList from "./pages/cadastro/cadchecklist";
import CadLojinha from './pages/cadastro/cadlojinha';
import CadEvento from './pages/cadastro/cadevento';
import CadOrcamento from "./pages/cadastro/cadorcamento";
import RelHumor from './pages/relatorio/relhumor';
import RelPonto from './pages/relatorio/relponto';
import RelSaldoPonto from './pages/relatorio/relsaldoponto';
import RelPontoErro from './pages/relatorio/relpontoerro';
import RelCheckList from "./pages/relatorio/relchecklist";
import AjustePonto from './pages/operacoes/ajusteponto';
import ReceberMissaoDesafio from './pages/operacoes/recebermissaodesafio';
import Feedback from './pages/operacoes/feedback';
import OpeTarefaFinalizada from "./pages/operacoes/tarefafinalizada";

import Sidebar from './componente/sidebar';
import { AppProvider } from './context/AppContext';
import './style/global.css';

function AppRoutes() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/';

  return (
    <div className="app-layout">
      {!isLoginPage && <Sidebar />}
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/principal" element={<Principal />} />
          <Route path="/configuracao" element={<Configuracao />} />
          <Route path="/setor" element={<CadSetor />} />
          <Route path="/funcao" element={<CadFuncao />} />
          <Route path="/colaborador" element={<CadColaborador />} />
          <Route path="/equipe" element={<CadEquipe />} />
          <Route path="/titulo" element={<CadTitulo />} />
          <Route path="/desafio" element={<CadDesafio />} />
          <Route path="/checklist" element={<CadCheckList />} />
          <Route path="/lojinha" element={<CadLojinha />} />
          <Route path="/evento" element={<CadEvento />} />
          <Route path="/orcamento" element={<CadOrcamento />} />
          <Route path="/ope/ajusteponto" element={<AjustePonto />} />
          <Route path="/ope/recebermissaodesafio" element={<ReceberMissaoDesafio />} />
          <Route path="/ope/feedback" element={<Feedback />} />
          <Route path="/ope/checklist" element={<OpeTarefaFinalizada />} />
          <Route path="/rel/humor" element={<RelHumor />} />
          <Route path="/rel/ponto" element={<RelPonto />} />
          <Route path="/rel/saldoponto" element={<RelSaldoPonto />} />
          <Route path="/rel/pontoerro" element={<RelPontoErro />} />
          <Route path="/rel/checklist" element={<RelCheckList />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <AppProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AppProvider>
  );
}

export default App;
